var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesDons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.016 10C17.776 10 20.016 7.76 20.016 5C20.016 2.24 17.776 0 15.016 0C12.256 0 10.016 2.24 10.016 5C10.016 7.76 12.256 10 15.016 10ZM20.466 15.6C20.076 15.2 19.586 15 19.016 15H12.016L9.936 14.27L10.266 13.33L12.016 14H14.816C15.166 14 15.446 13.86 15.676 13.63C15.906 13.4 16.016 13.12 16.016 12.81C16.016 12.27 15.756 11.9 15.236 11.69L7.966 9H6.016V18L13.016 20L21.046 17C21.056 16.47 20.856 16 20.466 15.6ZM4.016 9H0V20H4.016V9Z",
    fill: "#314F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesDons);
export default __webpack_public_path__ + "static/media/MesDons.46a2f23736b56fcf653782410bbcc9d6.svg";
export { ForwardRef as ReactComponent };